import './App.scss';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, RequireAuth } from './auth';

import Login from './components/login';
import ResetPassword from './components/resetPassword';
import AdminCollaborators from './components/collaborators';
import AdminCompanies from './components/admin';
import Documents from './components/documents';

import Contract from './components/contract';
import Mixts from './components/mixts';
import Features from './components/features';
import Demmits from './components/demmits';

import Dashboard from './components/dashboard';

import Super from './components/super';




function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/restablecer" element={<ResetPassword />} />
            <Route
              path="/admin"
              element={
                <RequireAuth requiredRole="admin" children={AdminCompanies}>
                  <AdminCompanies />
                </RequireAuth>
              }
            />
            <Route
              path='/dashboard'
              element={
                <RequireAuth requiredRole="admin" children={Dashboard}>
                  <Dashboard />
                </RequireAuth>
              }
            />

            <Route
              path='/admin/collaborators'
              element={
                <RequireAuth requiredRole="admin" children={AdminCollaborators}>
                  <AdminCollaborators />
                </RequireAuth>
              }
            />
            <Route
              path='/admin/documents'
              element={
                <RequireAuth requiredRole="admin" children={Documents}>
                  <Documents />
                </RequireAuth>
              }
            />
            <Route
              path='/admin/contract'
              element={
                <RequireAuth requiredRole="admin" children={Contract}>
                  <Contract />
                </RequireAuth>
              }

            />
            <Route
              path='/admin/mixts'
              element={
                <RequireAuth requiredRole="admin" children={Mixts}>
                  <Mixts />
                </RequireAuth>
              }

            />

            <Route
              path='/admin/features'
              element={
                <RequireAuth requiredRole="admin" children={Features}>
                  <Features />
                </RequireAuth>
              }

            />

            <Route
              path='/admin/demmits'
              element={
                <RequireAuth requiredRole="admin" children={Demmits}>
                  <Demmits />
                </RequireAuth>
              }

            />


            <Route
              path="/super"
              element={
                <RequireAuth requiredRole="super" children={Super}>
                  <Super />
                </RequireAuth>
              }
            />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
